import { createTheme } from '@mui/material/styles';

/** MUI 主题：品牌色 #4F6BFF（浅色高级感） */
export const theme = createTheme({
  palette: {
    primary: {
      main: '#4F6BFF',
      light: '#EAF1FF',
      dark: '#3B4FD8',
    },
    background: {
      default: '#FAFBFC',
    },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
  },
});
